import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Text = styled.p`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  margin: 0;
  font-size: 14px;
  line-height: 120%;
  color: ${props => props.theme.primaryColor};
  text-transform: uppercase;
`;

export default function Caption({ name }) {
  return <Text>{name}</Text>;
}

Caption.propTypes = { name: PropTypes.string.isRequired };
